<div class="success-container">
  @if (platform() == platformType.desktop) {
  <img class="logo" src="assets\images\success_icon.svg" />
  }@else{
  <app-plusmore-card
    [cardNumber]="store.cardNumber()"
    [name]="store.fullName()"
  ></app-plusmore-card>
  <app-spacer height="8px"></app-spacer>
  }

  <app-spacer height="8px"></app-spacer>

  <div class="text-container">
    <span class="title">Congrats! You are now registered for +more</span>
    <p class="subtitle">
      Download the app now and link your profile, for instant access to rewards and exclusive
      features.
    </p>
  </div>
  <app-spacer height="8px"></app-spacer>

  @if (platform() == platformType.desktop) {
  <mat-form-field class="card-number w-full" appearance="outline">
    <mat-label>Card number</mat-label>
    <input
      matInput
      [placeholder]="'Card number'"
      [readonly]="true"
      [value]="store.cardNumber() | formatCardNumber"
    />
  </mat-form-field>
  }

  <div class="section-container">
    @if( platform() === platformType.desktop) {
    <qrcode
      [qrdata]="'https://plusmore.co.za/redirect?route=join?cardNumber=' + store.cardNumber()"
      [width]="220"
      [errorCorrectionLevel]="'M'"
    ></qrcode>
    }
    <app-spacer height="16px"></app-spacer>
    <div class="link-container">
      @if(platform() === platformType.android || platform() === platformType.desktop) {
      <a [href]="androidLink" target="_blank" rel="noopener noreferrer" class="store-link">
        <img class="logo" src="assets\images\google_play_button.svg"
      /></a>
      } @if(platform() === platformType.ios || platform() === platformType.desktop) {
      <a
        href="https://apps.apple.com/za/app/more/id6447191406"
        target="_blank"
        rel="noopener noreferrer"
        class="store-link"
      >
        <img class="logo" src="assets\images\appstore_button.svg"
      /></a>
      }
    </div>

    <app-spacer height="25px"></app-spacer>

    <div class="button-container">
      <a
        href="https://plusmore.co.za/support"
        class="action-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <app-outline-button [text]="'View our FAQ’s'"></app-outline-button
      ></a>

      <a href="https://plusmore.co.za" class="action-button">
        <app-primary-button [text]="'Back to +more'"></app-primary-button>
      </a>
    </div>
  </div>
</div>
